import { useMemo } from "react"
import { chain, get, reduce, pickBy, isEmpty } from "lodash"

// Filter metrics based on the data available for all position sets
export default function useFilteredMetrics(availableMetrics, allPositionSetsTimeSeries) {
  return useMemo(() => {
    const metricsWithData = reduce(allPositionSetsTimeSeries, (nonZero, timeSeries) => ({
      ...nonZero,
      ...reduce(timeSeries.values.dates, (keys, date) => ({
        ...keys,
        ...pickBy(date, value => value !== 0 && value != null),
      }), {}),
    }), {})

    const groupedMetricsWithData = chain(availableMetrics)
      .map(({ options }) => options)
      .flatten()
      .filter((metric) => get(metricsWithData, metric.id))
      .groupBy("category")
      .value()

    return chain(availableMetrics)
      .map(metric => ({
        ...metric,
        options: groupedMetricsWithData[metric.id],
      }))
      .filter(metric => !isEmpty(metric.options))
      .value()
  }, [availableMetrics, allPositionSetsTimeSeries])
}
